export const defaultState = {
  isSynchronising: false,
  showLoadingScreen: false,
  loadingScreenMsg: "",
  hasFailed: false,
  errorMsg: "",
  data: {},
};
